<template>
  <button type="button" class="btn-info">
    <i v-if="icon" :class="icon" />
    <span v-if="icon" class="space-icon" />{{ label }}
  </button>
</template>

<script>
export default {
  name: "InfoButton",
  props: ["label", "icon"],
};
</script>
